module.exports = __webpack_public_path__ + "static/img/kaisa-logo.c5890627.png";